import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import './vendor'
import Moonpull from './plugins/moonpull/Moonpull'
import VueApollo from 'vue-apollo'
import ApolloClient from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import VueCompositionAPI, { provide } from '@vue/composition-api'

// Vue 3 Composition API
Vue.use(VueCompositionAPI)

// Automatically load base components
const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /M[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {

  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      // @ts-ignore
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )


  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

// Initialise Apollo GraphQL
const httpLink = createHttpLink({ uri: `${process.env.VUE_APP_MOONPULL_API_ENDPOINT}/gql` })
const authLink = setContext(async (_, { headers }) => {

  // Check for login status + refresh token if necessary
  if (await Vue.prototype.$moonpull.isLoggedIn()) {
    return {
      headers: {
        ...headers,
        ...Vue.prototype.$moonpull.getAuthHeader()
      }
    }
  }
  return { headers }
})
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache'
    },
    query: {
      fetchPolicy: 'no-cache'
    },
    mutate: {
      fetchPolicy: 'no-cache'
    }
  }
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

// Moonpull API
Vue.use(Moonpull, { store, router, apolloClient })

Vue.config.productionTip = false
new Vue({
  
  // Vue services
  apolloProvider,
  router,
  store,
  render: h => h(App),

  // Composition API setup
  setup() {
    provide('$apollo', apolloClient)
    provide('$moonpull', Vue.prototype.$moonpull)
    provide('$router', router)
    provide('$store', store)
  },
}).$mount('#app')
